import React, { SyntheticEvent } from 'react';

import { IconButton } from '@vimeo/bokeh';
import { SearchMagnifier } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';

interface Props {
  onClick: (e?: SyntheticEvent<HTMLButtonElement>) => void;
  'data-testid'?: string;
}

export function SearchToggle({ ...props }: Props) {
  return (
    <IconButton
      aria-label={translate({ singular: 'Search', dictionary: { "es": { singular: "Buscar" }, "de-DE": { singular: "Suchen" }, "fr-FR": { singular: "Chercher" }, "ja-JP": { singular: "\u691C\u7D22" }, "ko-KR": { singular: "\uAC80\uC0C9" }, "pt-BR": { singular: "Pesquisar" }, "zh-CN": { singular: "\u641C\u7D22" } } })}
      id="searchToggle"
      icon={<SearchMagnifier />}
      variant="tertiary"
      size={{ base: 'sm', sm: 'md' }}
      {...props} />);


}